import { Options, Vue } from 'vue-class-component';
import { getMenuTree } from "@/api/index";
import { NavsDto } from '@/model/web/NavsDto';

import { getUserInfo } from "@/api/index";
@Options({})
export default class Header extends Vue {
    public  userInfo = '';
    public getUser() {
        getUserInfo().then((res: any) => {
           this.userInfo= res.data;
           localStorage.setItem('userId',res.data.id);
        });
    }

    public loginout(){
        sessionStorage.setItem('token','');
        this.$router.replace('/login');
    }
    public mounted() {
        this.getUser();
    }
 

}
